import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import { PageContentStack } from "atoms/Stack";
import Stack from "atoms/Stack";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK, COLOR_WHITE_LIGHTER } from "helpers/colors";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import useEnforceAuth from "helpers/useEnforceAuth";
import useRouteState from "helpers/useRouteState";
import React from "react";
import { TeamPageTitle } from "shared/PageTitle";

import LeaderboardTableSegment, { LeaderboardTableSegmentFragment } from "./leaderboard/LeaderboardTableSegment";
import TeamPagesHeader from "./team/TeamPagesHeader";
import TeamSeasonSelectSubnav from "./team/TeamSeasonSelectSubnav";

export default function TeamLeaderboardPage({ teamId }) {
  useEnforceAuth({ enforceAuthenticated: true });

  const [seasonId, seasonIdSet] = useRouteState("seasonId");
  const [data] = useData(
    gql`
      query TeamLeaderboardPage($teamId: ID!, $seasonId: ID) {
        team(id: $teamId) {
          id
          leaderboardTableSegments(seasonId: $seasonId) {
            title
            ...LeaderboardTableSegmentFragment
          }
        }
      }
      ${LeaderboardTableSegmentFragment}
    `,
    { teamId, seasonId },
  );

  return (
    <>
      <TeamPageTitle title="Leaderboard" />
      <TeamPagesHeader teamId={teamId} tab="leaderboard" />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <TeamSeasonSelectSubnav teamId={teamId} seasonId={seasonId} seasonIdSet={seasonIdSet} allowAllSeasons />
      </div>
      <PageContentStack>
        <Stack
          gap={SPACING}
          style={{ margin: "0 auto", maxWidth: MAX_CONTENT_WIDTH, width: `calc(100vw - ${SPACING} * 2)` }}
        >
          {data?.team?.leaderboardTableSegments?.map((leaderboardTableSegment) => (
            <LeaderboardTableSegment
              key={leaderboardTableSegment.title}
              leaderboardTableSegment={leaderboardTableSegment}
              collapsible={true}
            />
          ))}
        </Stack>
      </PageContentStack>
    </>
  );
}
